import { render, staticRenderFns } from "./IntegralWater.vue?vue&type=template&id=84ce9916&"
import script from "./IntegralWater.vue?vue&type=script&lang=js&"
export * from "./IntegralWater.vue?vue&type=script&lang=js&"
import style0 from "./IntegralWater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports